import { useCallback } from 'react';

import { SignaalBericht } from '@/types/Signalen';

import { useFetchWithAuth } from '../useFetchWithAuth';

export const useFetchSignaal = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetchSignaalBericht = useCallback(
    async (berichtId: string) => {
      const response = await fetchWithAuth(`/signalen/${berichtId}`);
      if (response.status > 499) {
        throw new Error(`Serverfout ${response.status}: ${response.statusText}`);
      } else if (!response.ok) {
        throw new Error(`Clientfout ${response.status}: ${response.statusText}`);
      } else {
        return (await response.json()) as SignaalBericht;
      }
    },
    [fetchWithAuth],
  );

  return { fetchSignaalBericht };
};
